import { menu as templatesMenu } from './templates/menu';
import { menu as parametrosMenu } from './parametros/menu';

export const administracaoMenu = {
    label: 'Administração',
    icon: 'pi pi-fw pi-cog',
    rules: [...templatesMenu.rules, ...parametrosMenu.rules],
    items: [templatesMenu, parametrosMenu],
};
